import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from './AuthContext';

const ProtectedRoute = ({ children }) => {
    const {
        isAuthenticated,
        loading
    } = useContext(AuthContext);

    const location = useLocation();

    const userType = localStorage.getItem('user_type');


    // ==========================================
    // WAIT FOR AUTHENTICATION CHECK
    // ==========================================
    if (loading) {
        return <div>Loading...</div>;
    }


    // ==========================================
    // USER NOT LOGGED IN
    // ==========================================
    if (!isAuthenticated) {
        return (
            <Navigate
                to="/login"
                replace
            />
        );
    }


    // ==========================================
    // USER TYPE 4
    // DEALER ONLY
    //
    // Type 4 can ONLY access:
    // /dealer
    //
    // Any other protected route will redirect
    // to /dealer
    // ==========================================
    if (String(userType) === '4') {

        if (location.pathname !== '/dealer') {

            return (
                <Navigate
                    to="/dealer"
                    replace
                />
            );
        }
    }


    // ==========================================
    // ALL OTHER USER TYPES
    //
    // Keep their existing access behavior.
    // ==========================================
    return children;
};

export default ProtectedRoute;